import React, { useContext, useLayoutEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import _insertCss from 'isomorphic-style-loader/insertCss';
import StyleContext from 'isomorphic-style-loader/StyleContext';

const isServer = typeof window === 'undefined';

function Deobfuscator(props) {
  const { book, children } = props;
  const { font, isbn } = book;
  const { insertCss } = useContext(StyleContext);
  const fontName = `font-${isbn}`;

  const runEffect = useCallback(
    () => {
      if (font) {
        const css = `
          @font-face {        
            font-family: '${fontName}';   
            font-display: block;     
            src: url('${font}');    
          }
        `;
        const content = [[fontName, css, '']];
        const removeCss = insertCss({
          _getCss: () => css,
          _insertCss: options => _insertCss(content, options),
          _getContent: () => content,
        });
        return () => {
          setTimeout(removeCss, 0);
        };
      }
      return () => {};
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [font, fontName],
  );

  useLayoutEffect(() => runEffect(), [runEffect]);
  if (isServer) {
    runEffect();
  }
  if (font) {
    return <div style={{ fontFamily: fontName }}>{children}</div>;
  }
  return children;
}

Deobfuscator.propTypes = {
  book: PropTypes.shape({
    font: PropTypes.string,
    isbn: PropTypes.string,
  }).isRequired,
  children: PropTypes.node.isRequired,
};

Deobfuscator.defaultProps = {};

export default Deobfuscator;
